import { jsx as H } from "react/jsx-runtime";
import { c as z } from "react/compiler-runtime";
import P from "highcharts";
import A from "highcharts-react-official";
import L from "highcharts/highcharts-more";
L(P);
const F = (W) => {
  const e = z(25), {
    data: g,
    categories: t,
    title: S,
    style: b
  } = W, _ = S === void 0 ? "" : S;
  let a;
  if (e[0] !== t || e[1] !== g) {
    let y;
    e[3] !== t ? (y = (k) => ({
      name: k.name?.toString(),
      type: "area",
      data: t.map((v) => k[v]),
      pointPlacement: "on"
    }), e[3] = t, e[4] = y) : y = e[4], a = g.map(y), e[0] = t, e[1] = g, e[2] = a;
  } else
    a = e[2];
  const x = a;
  let r, s, n;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = {
    enabled: !1
  }, s = {
    enabled: !1
  }, n = {
    polar: !0,
    type: "area",
    backgroundColor: "transparent"
  }, e[5] = r, e[6] = s, e[7] = n) : (r = e[5], s = e[6], n = e[7]);
  let l;
  e[8] !== _ ? (l = {
    text: _
  }, e[8] = _, e[9] = l) : l = e[9];
  let c;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    size: "80%"
  }, e[10] = c) : c = e[10];
  let o;
  e[11] !== t ? (o = {
    categories: t,
    tickmarkPlacement: "on",
    lineWidth: 0
  }, e[11] = t, e[12] = o) : o = e[12];
  let m, f;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = {
    gridLineInterpolation: "polygon",
    lineWidth: 0,
    min: 0
  }, m = {
    shared: !1,
    pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f}</b><br/>'
  }, e[13] = m, e[14] = f) : (m = e[13], f = e[14]);
  let p;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = {
    series: {
      fillOpacity: 0.1,
      dataLabels: {
        style: {
          fontSize: "10px",
          fontWeight: "normal",
          background: "transparent"
        }
      }
    }
  }, e[15] = p) : p = e[15];
  let h;
  e[16] !== x || e[17] !== l || e[18] !== o ? (h = {
    credits: r,
    exporting: s,
    chart: n,
    title: l,
    pane: c,
    xAxis: o,
    yAxis: f,
    tooltip: m,
    plotOptions: p,
    series: x
  }, e[16] = x, e[17] = l, e[18] = o, e[19] = h) : h = e[19];
  const u = h;
  let i;
  e[20] !== b ? (i = {
    style: {
      height: "100%",
      ...b
    }
  }, e[20] = b, e[21] = i) : i = e[21];
  let d;
  return e[22] !== u || e[23] !== i ? (d = /* @__PURE__ */ H("div", { children: /* @__PURE__ */ H(A, { highcharts: P, options: u, containerProps: i }) }), e[22] = u, e[23] = i, e[24] = d) : d = e[24], d;
};
export {
  F as default
};
